import { useBroadcast } from '../api/useBroadcast';

interface QuotedBroadcastPreviewProps {
  broadcastId: string;
}

const wrapperStyle: React.CSSProperties = {
  borderLeft: '3px solid #6b7280',
  background: 'rgba(0, 0, 0, 0.04)',
  padding: '6px 10px',
  margin: '4px 0',
  borderRadius: 4,
  fontSize: 12,
  color: '#374151',
};

const labelStyle: React.CSSProperties = {
  fontSize: 10,
  fontWeight: 600,
  textTransform: 'uppercase',
  color: '#6b7280',
  letterSpacing: 0.4,
  marginBottom: 2,
};

export function QuotedBroadcastPreview({
  broadcastId,
}: QuotedBroadcastPreviewProps) {
  const { broadcast, loading } = useBroadcast(broadcastId);

  if (loading) {
    return (
      <div style={wrapperStyle}>
        <div style={labelStyle}>Replying to broadcast</div>
        <div style={{ color: '#9ca3af' }}>Loading…</div>
      </div>
    );
  }
  if (!broadcast) return null;

  return (
    <div style={wrapperStyle}>
      <div style={labelStyle}>Replying to broadcast</div>
      <div
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {broadcast.content}
      </div>
    </div>
  );
}
